import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useDashboardSearchCondition } from '@/providers/DashboardSearchConditionProvider';
import { useDashboardPhaseCountAndAmounts } from '@/hooks/api/2070_dashboard_phase_count_and_amounts';
import { useEffect, useState } from 'react';
import { MotionDiv } from '@/components/element/MotionDiv';

export const AmountByPhase = () => {
  const { _w_ } = useCurrentWorkspace();
  const { salesOrdersDashboardSearchCondition: searchCondition, setSalesOrdersDashboardSearchCondition: setSearchCondition } = useDashboardSearchCondition();
  const { data } = useDashboardPhaseCountAndAmounts({ ...searchCondition, identifier: _w_!.identifier });
  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    if (!data) return;

    setTotal(data.reduce((sum, d) => d.amount + sum, 0));
  }, [data]);

  if (!data) return <></>;

  return (
    <MotionDiv className="col-lg-6 col-xl-4">
      <div className="card mb-4 mb-lg-3">
        <div className="card-header pb-0 p-3">
          <h6 className="mb-0">フェーズ別</h6>
        </div>
        <div className="card-body">
          {data.map((d, i) => (
            <div key={`a-b-p-${i}`} className="progress-wrapper">
              <div className="d-flex align-items-center mb-2">
                <h6 className="text-xs mb-0">{d.name}</h6>
                <div className="flex-1 text-end text-xs text-mute">¥{d.amount.toLocaleString()}</div>
              </div>
              <div className="progress">
                <div className="progress-bar-main" style={{ width: `${Math.trunc((d.amount / total) * 100)}%` }}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MotionDiv>
  );
};
